import * as Yup from 'yup';

export const eventCategorySchema = Yup.object().shape({
    category: Yup.string()
        .required('Categoria obrigatória')
        .max(80, 'A categoria pode ter até 80 caracteres'),
    url_src: Yup.string()
        .required('URL obrigatória')
        .max(20, 'A URL pode ter até 20 caracteres'),
});